<template>
  <v-alert
    v-if="error"
    outlined
    dense
    type="error"
    role="alert"
    class="admin-request-state"
  >
    <div class="admin-request-state__content">
      <span>{{ error }}</span>
      <v-btn
        small
        outlined
        :loading="loading"
        :disabled="loading"
        @click="$emit('retry')"
      >
        Tekrar dene
      </v-btn>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: 'AdminRequestState',
  props: {
    error: { type: String, default: '' },
    loading: { type: Boolean, default: false },
  },
}
</script>

<style scoped>
.admin-request-state { margin: 12px 16px; }
.admin-request-state__content { display: flex; align-items: center; justify-content: space-between; gap: 12px; flex-wrap: wrap; }
</style>
